// extracted by mini-css-extract-plugin
export default {"ns_link_parent":"NSLink_ns_link_parent__7jk0V","ns_link":"NSLink_ns_link__Y64mY","ns_link_absolute":"NSLink_ns_link_absolute__sp2iT"};